import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'commentsFidelity',
    label: 'Fidelity Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
